import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as VocaExampleImg} from '../../assets/admin05/voca-example.svg';
import {ReactComponent as VocaExampleMediumImg} from '../../assets/admin05/voca-example-md.svg';
import {ReactComponent as VocaImg} from '../../assets/admin05/voca.svg';

export default function Admin05() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const getSubTitle = () => {
        if (mobileSmall) return <>실제 사용되는 단어를 등록하여<br />AI의 이해도를 높이세요</>;
        if (mobileMedium) return <>실제 사용되는 단어를 등록하여 AI의 이해도를<br />높이세요</>;

        return '실제 사용되는 단어를 등록하여 AI의 이해도를 높이세요';
    };

    const dataMap = [
        { 
            type: 'voca-example',
            title: '단어 사전을 만들어보세요',
            subTitle: getSubTitle(),
            Image: mobileMedium ? VocaExampleMediumImg : VocaExampleImg
        }
    ];

    return (
        <div>
            <FeatureCardBox
                type='voca'
                IconImage={VocaImg}
                keyword='단어장'
                title='전문 용어도 문제없어요!'
                featureCardList={dataMap}
                titleMotion={serviceMotionList.titleMotion}
                cardMotion={serviceMotionList.cardMotion}
            />
        </div>
    );
}
